// extracted by mini-css-extract-plugin
module.exports = {"productsList":"styles_productsList__jExlN","productItem":"styles_productItem__ppRn2"};